import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMiViewPlanSelector from './MiViewPlanSelector.hook';
import {
  formControlStyle,
  selectStyle,
  inputLabelStyle,
  menuItemStyle,
  selectPaperStyle,
} from './MiViewPlanSelector.style';

import { PlanSelectorProps } from './MiViewPlanSelector.types';

const MiViewPlanSelector: React.FC<PlanSelectorProps> = ({
  minWidth,
  defaultPlan,
  plans,
}) => {
  const { t } = useTranslation();
  const { handleChange, selectedPlan } = useMiViewPlanSelector(defaultPlan, plans);

  return (
    <FormControl size="small" sx={ { ...formControlStyle, minWidth } }>
      <InputLabel sx={ inputLabelStyle }>
        { t('maya_miview_cep_dropdown_label') }
      </InputLabel>
      <Select
        sx={ selectStyle }
        size="small"
        value={ selectedPlan?.id || '' }
        onChange={ handleChange }
        label={ t('maya_miview_cep_dropdown_label') }
        MenuProps={
          {
            PaperProps: {
              sx: { ...selectPaperStyle },
            },
          }
        }
      >
        <MenuItem value="" sx={ menuItemStyle }>
          { t('maya_miview_dropdown_none_label') }
        </MenuItem>

        {
          plans?.map((plan, index) => (
            <MenuItem key={ index } value={ plan?.id || '' } sx={ menuItemStyle }>
              { plan.name || '' }
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

export default MiViewPlanSelector;

